import React from "react";
import { useDispatch } from "react-redux";
import RegularButton from "components/CustomButtons/Button";
import { deleteUser } from "redux/actions/users/usersActions";
import { Typography } from "@mui/material";
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';
import { red } from "@mui/material/colors";

export const DeleteUserForm = ({ data, onClose }) => {
  const {username, id} = data
  const dispatch = useDispatch()
  const handleDelete = () => {
    dispatch( deleteUser(id, onClose) )
  }
  return (
    <div style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      alignItems: 'center'
    }}>
      <Typography variant="body1" align="center">Eliminar usuario: {username}</Typography>
      <PersonAddDisabledIcon style={{
        color: red[200], fontSize: 120
      }}/>
      <div style={{
        width: '100%',
        display: 'flex', 
        justifyContent: 'center',
        gap: 4
      }}>
        <RegularButton
          color="white"
          onClick={onClose}
        >
          Cancelar
        </RegularButton>
        <RegularButton
          color="danger"
          onClick={handleDelete}
        >
          Confirmar
        </RegularButton>
      </div>
    </div>
  );
};
